<template>
  <v-main>
    <navigation v-if="!liffUser"/>
    <v-container fluid>
      <v-row dense>
        <v-col v-if="clinicUser" cols="12" md="2" xl="1"
               :class="[{ 'tab-col': $vuetify.breakpoint.mdAndUp }, 'overflow-y-auto']">
          <clinic-reserve-tabs :value.sync="currentTab" :tab-items.sync="tabItems" @refresh="getDoctor"/>
        </v-col>
        <v-col v-else cols="12" md="2" xl="1">
          <reserve-tabs :value.sync="currentTab" :tab-items.sync="tabItems" @refresh="getClinic"/>
        </v-col>
        <v-col cols="12" md="10" xl="11">
          <mid-autumn-banner/>
          <ReserveCalendar v-if="tabItems" :tabItems="tabItems" :currentTab="currentTab"/>
        </v-col>
      </v-row>
    </v-container>
    <WelcomeOnBoard v-if="showWelcome" @start="onWelcomeStart"/>
    <EndOnBoard v-if="showEndOnBoardComputed" @start="onWelcomeEnd"/>
  </v-main>
</template>

<script>
import MidAutumnBanner from '@/components/message/MidAutumnBanner.vue';
import Navigation from '../components/Navigation';
import ReserveCalendar from "../components/reserve/ReserveCalendar";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { getClinicListAPI, getDoctorListAPI } from "../api";
import ReserveTabs from "../components/reserve/ReserveTabs";
import ClinicReserveTabs from "../components/reserve/ClinicReserveTabs";
import onboarding from "@/tours/onboarding";
import WelcomeOnBoard from "@/components/utils/tour/WelcomeOnBoard.vue";
import EndOnBoard from "@/components/utils/tour/EndOnBoard.vue";
import { clinicList } from "@/api/mockData/tour/onboarding";

export default {
  components: {
    MidAutumnBanner,
    EndOnBoard,
    WelcomeOnBoard,
    ClinicReserveTabs,
    ReserveTabs,
    Navigation,
    ReserveCalendar
  },
  data() {
    return {
      currentTab: 'all',
      tabItems: [],
      showWelcome: false
    }
  },
  computed: {
    ...mapGetters([
      'axiosParamData',
      'clinicUser',
      'liffUser'
    ]),
    ...mapGetters('tour', {
      currentTourName: 'currentTourName'
    }),
    ...mapState([
      'popUpNotice',
    ]),
    showEndOnBoardComputed: {
      get() {
        return this.$store.getters['tour/showEndObBoardDialog']
      },
      set(isOpen) {
        this.$store.commit('tour/setShowEndObBoardDialog', isOpen)
      }
    },
  },
  watch: {
    currentTourName(newV, oldV) {
      if (oldV === 'onboarding') {
        this.getClinic()
      }
    }
  },
  methods: {
    ...mapMutations({
      setPopUpNotice: 'setPopUpNotice'
    }),
    getClinic() {
      getClinicListAPI(this.axiosParamData).then(res => {
        this.tabItems = res.data
      })
    },
    getDoctor() {
      getDoctorListAPI(this.axiosParamData).then(res => {
        this.tabItems = res.data
      })
    },
    onWelcomeStart() {
      this.showWelcome = false

      this.$tourManager.start(onboarding);
      // localStorage.removeItem('isNewUser');
    },
    onWelcomeEnd() {
      this.showEndOnBoardComputed = false

      if (this.popUpNotice) {  // force show popUpNotice
        const tmp = JSON.parse(JSON.stringify(this.popUpNotice))
        this.setPopUpNotice(tmp)
      }
    }
  },
  mounted() {
    if (onboarding.shouldStart()) {
      this.showWelcome = true
      if (this.clinicUser) {

      } else {
        this.tabItems = clinicList
      }
    } else {
      if (this.clinicUser) {
        this.getDoctor()
      } else {
        if (this.currentTourName === 'onboarding') {
          this.tabItems = clinicList
        } else {
          this.getClinic()
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.tab-col {
  height: calc(100vh - 80px);
}
</style>
